import React from 'react';
import { Chart } from 'chart.js';

import { MAIN_ANALYTICS_CHART_COLORS } from './chart.constants';
import { registerMainAnalyticsCharts } from './register-main-analytics-charts';

type DoughnutChartProps = {
   label: string;
   labels: string[];
   values: number[];
   colors?: string[];
};

export const DoughnutChart = ({
   label,
   labels,
   values,
   colors = MAIN_ANALYTICS_CHART_COLORS,
}: DoughnutChartProps) => {
   const canvasRef = React.useRef<HTMLCanvasElement | null>(null);

   React.useEffect(() => {
      registerMainAnalyticsCharts();

      const canvas = canvasRef.current;
      if (!canvas) {
         return undefined;
      }

      const chart = new Chart(canvas, {
         type: 'doughnut',
         data: {
            labels,
            datasets: [
               {
                  data: values,
                  backgroundColor: colors,
                  borderColor: '#ffffff',
                  borderWidth: 2,
               },
            ],
         },
         options: {
            cutout: '62%',
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
               legend: {
                  position: 'right',
                  labels: {
                     boxWidth: 10,
                     boxHeight: 10,
                     usePointStyle: true,
                     color: '#202020',
                  },
               },
            },
         },
      });

      return () => chart.destroy();
   }, [colors, labels, values]);

   return <canvas ref={canvasRef} role="img" aria-label={label} />;
};
